// Kept in its own module so test setup can clear it without importing the
// hook's module graph, which would break per-file mocks.
export const STEP_0_ELIGIBILITY_PREVIEW_COOKIE =
  'iw-uk-step-0-eligibility-preview';
